import { IconButton, Stack } from "@mui/material";

import { ClosedCaptioningIcon, MicrophoneIcon, MicrophoneSlashIcon, MonitorArrowUpIcon, PencilSimpleIcon, PhoneXIcon, ProhibitIcon, VideoCameraIcon, VideoCameraSlashIcon } from "@phosphor-icons/react/dist/ssr";

interface VideoControlsProps {
  isMicEnabled: boolean;
  isCameraEnabled: boolean;
  onToggleAudio: () => void;
  onToggleVideo: () => void;
  onDisconnect?: () => void;
  isTranscribing?: boolean;
  onToggleTranscription?: () => void;
  onToggleScreenShare?: () => void;
  onToggleWhiteboard?: () => void;
  isScreenSharing?: boolean;
  isSandbox?: boolean;
}

function VideoControls({
  isMicEnabled,
  isCameraEnabled,
  onToggleAudio,
  onToggleVideo,
  onDisconnect,
  isTranscribing = false,
  onToggleTranscription,
  onToggleScreenShare,
  onToggleWhiteboard,
  isScreenSharing = false,
  isSandbox = false,
}: VideoControlsProps) {
  return (
    <Stack direction="row" spacing={1}>
      {onToggleTranscription && (
        <IconButton sx={{
          width: 40,
          height: 40,
          color: isTranscribing ? "common.white" : "text.primary",
          backgroundColor: isTranscribing ? "secondary.main" : "transparent",
          borderRadius: 1.5,
          border: 1,
          borderColor: "secondary.main"
        }} onClick={onToggleTranscription} disabled={isSandbox}>
          <ClosedCaptioningIcon weight="fill" fontSize={24} />
        </IconButton>
      )}
      <IconButton sx={{
        width: 40,
        height: 40,
        color: "text.primary",
        borderRadius: 1.5,
        border: 1,
        borderColor: "secondary.main"
      }} onClick={onToggleVideo} disabled={isSandbox}>
        {isCameraEnabled ? <VideoCameraIcon weight="fill" fontSize={24} /> : <VideoCameraSlashIcon weight="fill" fontSize={24} />}
      </IconButton>
      <IconButton sx={{
        width: 40,
        height: 40,
        color: "text.primary",
        borderRadius: 1.5,
        border: 1,
        borderColor: "secondary.main"
      }} onClick={onToggleAudio} disabled={isSandbox}>
        {isMicEnabled ? <MicrophoneIcon weight="fill" fontSize={24} /> : <MicrophoneSlashIcon weight="fill" fontSize={24} />}
      </IconButton>
      {onToggleScreenShare && (
        <IconButton sx={{
          width: 40,
          height: 40,
          color: "text.primary",
          borderRadius: 1.5,
          border: 1,
          borderColor: "secondary.main"
        }} onClick={onToggleScreenShare} disabled={isSandbox}>
          {isScreenSharing ? <ProhibitIcon fontSize={24} weight="fill" /> : <MonitorArrowUpIcon fontSize={24} weight="fill" />}
        </IconButton>
      )}
      {onToggleWhiteboard && (
        <IconButton sx={{
          width: 40,
          height: 40,
          color: "text.primary",
          borderRadius: 1.5,
          border: 1,
          borderColor: "secondary.main"
        }} onClick={onToggleWhiteboard}>
          <PencilSimpleIcon weight="fill" fontSize={24} />
        </IconButton>
      )}
      {onDisconnect && (
        <IconButton sx={{
          width: 40,
          height: 40,
          color: "common.white",
          borderRadius: 1.5,
          backgroundColor: "error.dark",
          "&:hover": { backgroundColor: "error.main" }
        }} onClick={onDisconnect} disabled={isSandbox}>
          <PhoneXIcon fontSize={24} weight="fill" />
        </IconButton>
      )}
    </Stack>
  );
}

export default VideoControls;
